module.exports = __webpack_public_path__ + "static/image/logo-family/logo_bmart@3x.png?f916d3a4";